import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const API_BASE = 'https://backend-gocq.onrender.com'

export default function EntertenmentHome() {
  const navigate = useNavigate()
  const [featured, setFeatured] = useState([])
  const [small,    setSmall]    = useState([])
  const [loading,  setLoading]  = useState(true)

  useEffect(() => { fetchEntertainmentNews() }, [])

  const fetchEntertainmentNews = async () => {
    try {
      setLoading(true)
      const res  = await fetch(`${API_BASE}/api/news?category=Entertainment&status=published&limit=9&page=1`)
      const data = await res.json()
      if (data.success && data.data.length > 0) {
        setFeatured(data.data.slice(0, 3))
        setSmall(data.data.slice(3, 9))
      }
    } catch (err) {
      console.error('Entertainment fetch error:', err)
    } finally {
      setLoading(false)
    }
  }

  const getImageUrl = (p) => {
    if (!p) return 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&q=80'
    if (p.startsWith('http')) return p
    return `${API_BASE}${p}`
  }

  const getTimeAgo = (date) => {
    const diff = Date.now() - new Date(date)
    const m = Math.floor(diff / 60000)
    const h = Math.floor(m / 60)
    const d = Math.floor(h / 24)
    if (m < 1)  return 'अभी'
    if (m < 60) return `${m} मिनट पहले`
    if (h < 24) return `${h} घंटे पहले`
    if (d < 7)  return `${d} दिन पहले`
    return new Date(date).toLocaleDateString('hi-IN')
  }

  const formatViews = (v = 0) => {
    if (v >= 1e6) return `${(v / 1e6).toFixed(1)}M`
    if (v >= 1e3) return `${(v / 1e3).toFixed(1)}K`
    return v
  }

  const getTypeLabel = (type) => {
    const map = {
      trending:      '🔥 ट्रेंडिंग',
      top:           '⭐ टॉप',
      latest:        '🆕 ताज़ा',
      main:          '📰 मुख्य',
      business:      '💼 व्यापार',
      politics:      '🏛 राजनीति',
      sports:        '🏆 खेल',
      entertainment: '🎬 मनोरंजन',
      education:     '📚 शिक्षा',
      international: '🌍 अंतर्राष्ट्रीय',
    }
    return map[type] || '🎬 मनोरंजन'
  }

  const goToNews = (id) => { navigate(`/news/${id}`); window.scrollTo(0, 0) }

  // ── Skeleton ──
  if (loading) {
    return (
      <section style={styles.section}>
        <style>{shimmerCSS}</style>
        <div style={styles.header}>
          <div style={skeletonBox({ w: 140, h: 28, r: 6 })} />
          <div style={skeletonBox({ w: 70, h: 18, r: 4 })} />
        </div>
        <div style={styles.featuredGrid}>
          {[1, 2, 3].map(i => (
            <div key={i} style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #f0f0f0' }}>
              <div style={skeletonBox({ w: '100%', h: 200, r: 0 })} />
              <div style={{ padding: 14, background: '#fff', display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div style={skeletonBox({ w: '60%', h: 13, r: 4 })} />
                <div style={skeletonBox({ w: '100%', h: 13, r: 4 })} />
                <div style={skeletonBox({ w: '80%', h: 13, r: 4 })} />
              </div>
            </div>
          ))}
        </div>
      </section>
    )
  }

  if (!loading && featured.length === 0) return null

  return (
    <section style={styles.section}>
      <style>{`
        ${shimmerCSS}
        ${responsiveCSS}
        .ent-featured-card { transition: transform 0.25s ease, box-shadow 0.25s ease; cursor: pointer; }
        .ent-featured-card:hover { transform: translateY(-5px); box-shadow: 0 16px 36px rgba(0,0,0,0.14) !important; }
        .ent-featured-card:hover .ent-card-title { color: #c0267a; }
        .ent-featured-card img { transition: transform 0.4s ease; }
        .ent-featured-card:hover img { transform: scale(1.05); }
        .ent-small-card { transition: background 0.2s ease; cursor: pointer; }
        .ent-small-card:hover { background: #fff0f7 !important; }
        .ent-small-card:hover .ent-small-title { color: #c0267a; }
        .ent-see-more { transition: opacity 0.2s; cursor: pointer; }
        .ent-see-more:hover { opacity: 0.7; }
      `}</style>

      {/* ── Header ── */}
      <div style={styles.header}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <h2 style={styles.sectionTitle}>मनोरंजन</h2>
        </div>
        <span
          className="ent-see-more"
          style={styles.seeMore}
          onClick={() => navigate('/category/Entertainment')}
        >
          और देखें →
        </span>
      </div>

      {/* ── Featured 3 large cards ── */}
      <div className="ent-featured-grid" style={styles.featuredGrid}>
        {featured.map((article) => (
          <div
            key={article._id}
            className="ent-featured-card"
            style={styles.featuredCard}
            onClick={() => goToNews(article._id)}
          >
            {/* Image */}
            <div style={{ position: 'relative', height: 200, overflow: 'hidden' }}>
              <img
                src={getImageUrl(article.image)}
                alt={article.title}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&q=80' }}
              />

              {/* Type tag */}
              {article.type && (
                <span style={styles.tag}>{getTypeLabel(article.type)}</span>
              )}

              {/* Video badge */}
              {article.video && (
                <span style={styles.videoBadge}>▶ वीडियो</span>
              )}

              <div style={styles.overlay} />
            </div>

            {/* Content */}
            <div style={{ padding: 14, background: '#fff' }}>
              <span style={styles.categoryBadge}>मनोरंजन</span>
              <p className="ent-card-title" style={styles.featuredTitle}>{article.title}</p>
              {article.description && (
                <p style={styles.description}>{article.description}</p>
              )}
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                <span style={styles.time}>🕐 {getTimeAgo(article.createdAt)}</span>
                <span style={styles.time}>👁 {formatViews(article.views)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Divider ── */}
      <div style={styles.divider} />

      {/* ── Small 6 cards ── */}
      {small.length > 0 && (
        <div className="ent-small-grid" style={styles.smallGrid}>
          {small.map((article) => (
            <div
              key={article._id}
              className="ent-small-card"
              style={styles.smallCard}
              onClick={() => goToNews(article._id)}
            >
              {/* Thumbnail */}
              <div style={{ position: 'relative', flexShrink: 0 }}>
                <img
                  src={getImageUrl(article.image)}
                  alt={article.title}
                  style={styles.smallImg}
                  onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&q=80' }}
                />
                {article.video && (
                  <span style={styles.smallVideoBadge}>▶</span>
                )}
              </div>

              {/* Text */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <span style={styles.smallCategory}>{getTypeLabel(article.type)}</span>
                <p className="ent-small-title" style={styles.smallTitle}>{article.title}</p>
                <span style={styles.time}>🕐 {getTimeAgo(article.createdAt)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}

// ── Skeleton helper ──
const skeletonBox = ({ w, h, r = 4 }) => ({
  width: w,
  height: h,
  borderRadius: r,
  background: 'linear-gradient(90deg, #e5e7eb 25%, #f9fafb 50%, #e5e7eb 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.4s infinite',
})

// ── CSS strings ──
const shimmerCSS = `@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`

const responsiveCSS = `
  @media (max-width: 900px) {
    .ent-featured-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .ent-small-grid    { grid-template-columns: repeat(2, 1fr) !important; }
  }
  @media (max-width: 580px) {
    .ent-featured-grid { grid-template-columns: 1fr !important; }
    .ent-small-grid    { grid-template-columns: 1fr !important; }
  }
`

// ── Styles ──
const ACCENT = '#c0267a'   // 🩷 pink/magenta — entertainment theme

const styles = {
  section: {
    fontFamily: "'Noto Sans Devanagari', 'Hind', sans-serif",
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 16px',
    background: '#fff',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  sectionTitle: {
    fontSize: '22px',
    fontWeight: '800',
    color: '#1a1a2e',
    margin: 0,
    borderBottom: `3px solid ${ACCENT}`,
    paddingBottom: '4px',
  },
  seeMore: {
    fontSize: '13px',
    color: ACCENT,
    fontWeight: '600',
  },
  featuredGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '18px',
    marginBottom: '20px',
  },
  featuredCard: {
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid #f0f0f0',
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
  },
  tag: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    background: ACCENT,
    color: '#fff',
    fontSize: '11px',
    fontWeight: '700',
    padding: '3px 8px',
    borderRadius: '4px',
    zIndex: 2,
  },
  videoBadge: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'rgba(124,58,237,0.9)',
    color: '#fff',
    fontSize: '10px',
    fontWeight: '700',
    padding: '3px 7px',
    borderRadius: '4px',
    zIndex: 2,
  },
  overlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '60px',
    background: 'linear-gradient(to top, rgba(0,0,0,0.3), transparent)',
  },
  categoryBadge: {
    fontSize: '11px',
    fontWeight: '700',
    color: ACCENT,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    display: 'block',
    marginBottom: '4px',
  },
  featuredTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1a1a2e',
    margin: '0 0 6px',
    lineHeight: '1.5',
    transition: 'color 0.2s',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  description: {
    fontSize: '12px',
    color: '#666',
    margin: '0 0 8px',
    lineHeight: '1.4',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  time: {
    fontSize: '11px',
    color: '#999',
  },
  divider: {
    height: '1px',
    background: `linear-gradient(to right, ${ACCENT}, #f0f0f0)`,
    margin: '4px 0 20px',
  },
  smallGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '14px',
  },
  smallCard: {
    display: 'flex',
    gap: '12px',
    padding: '10px',
    borderRadius: '8px',
    alignItems: 'flex-start',
    border: '1px solid #f5f5f5',
    background: '#fff',
  },
  smallImg: {
    width: '80px',
    height: '64px',
    objectFit: 'cover',
    borderRadius: '6px',
    display: 'block',
  },
  smallVideoBadge: {
    position: 'absolute',
    bottom: 2,
    right: 2,
    background: 'rgba(124,58,237,0.85)',
    color: '#fff',
    fontSize: '9px',
    padding: '1px 4px',
    borderRadius: '3px',
  },
  smallCategory: {
    fontSize: '10px',
    fontWeight: '700',
    color: ACCENT,
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
    display: 'block',
    marginBottom: '4px',
  },
  smallTitle: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#1a1a2e',
    margin: '0 0 4px',
    lineHeight: '1.45',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    transition: 'color 0.2s',
  },
}